import { EditOutlined } from "@ant-design/icons";
import { Button, Select, Rate } from "antd";
import axios from "axios";
import moment from "moment";
import PropTypes from "prop-types";
import React, {
  ReactElement,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { getParamValue } from "../../utils";
import { authenticateToken } from "../../utils/auth";
import { responseNotification } from "../../utils/notify";
import { useLocation } from "react-router-dom";
import { useParams } from "react-router";
import _ from "lodash";

import CustomerHeader from "./Layout/topHeader";
import { useDispatch } from "react-redux";
import { SET_CUSTOMER_INFO } from "../../redux/auth/authType";
import CustomerLayout from "./Layout";
const { Option } = Select;

const UserDetails = ({ onCloseMethod, params }: any, props): ReactElement => {
  const [singleUserInfo, setSingleUserInfo] = useState({
    loading: false,
    data: null,
  });
  const route = useParams();
  const loc = useLocation();
  const page = getParamValue(loc.search, "page");
  const dispatch = useDispatch();

  const fetchUserDetails = useCallback((getUserId) => {
    if (getUserId) {
      try {
        setSingleUserInfo({ loading: true, data: undefined });
        axios
          .get(`${process.env.REACT_APP_RIDER_API}/admin/user/${getUserId}`, {
            headers: {
              Authorization: `Bearer ${authenticateToken()}`,
              "Content-Type": "application/json",
            },
          })
          .then((data) => {
            if (data.status === 200) {
              setSingleUserInfo({
                loading: false,
                data: data?.data?.user,
              });
              dispatch({
                type: SET_CUSTOMER_INFO,
                payload: {
                  customerInfo: {
                    // id: data?.data?.user?.id,
                    fullName: data?.data?.user?.fullName,
                    contactNumber: data?.data?.user?.contactNumber,
                    profilePicture: data?.data?.user?.profilePicture,
                    balance: data?.data?.user?.balance,
                    rating: data?.data?.user?.rating,
                    status: data?.data?.user?.status,
                  },
                },
              });
            } else {
              setSingleUserInfo({ loading: false, data: null });
              responseNotification(
                data.statusText || "something went wrong",
                "error"
              );
            }
          })
          .catch((err) => {
            setSingleUserInfo({ loading: false, data: null });

            console.log(err);
          });
      } catch (error) {
        setSingleUserInfo({ loading: false, data: null });

        console.log(error, "error");
      }
    }
  }, []);

  useEffect(() => {
    fetchUserDetails((route as any)?.id);
  }, [fetchUserDetails, (route as any)?.id]);

  // const getCategoryOptions = useCallback(
  //   async (value) => {
  //     setCategoryData({ loading: true, list: null });
  //     const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
  //     axios
  //       .get(
  //         `${encodedUri}/category/search?page=0&limit=20&isParent=true&type=${singleUserInfo?.data?.type}&key=${value}`,
  //         {
  //           headers: {
  //             Authorization: `Bearer ${authenticateToken()}`,
  //           },
  //         }
  //       )
  //       .then((res) => {
  //         setCategoryData({ loading: false, list: res.data });
  //       })
  //       .catch((err) => {
  //         setCategoryData({ loading: false, list: [] });
  //         console.error("Category: Error", err);
  //       });
  //   },
  //   [singleUserInfo?.data?.type]
  // );

  // useEffect(() => {
  //   if (singleUserInfo?.data?.type) {
  //     getCategoryOptions("");
  //   }
  // }, [getCategoryOptions]);

  function handleChange(value) {
    console.log(`selected ${value}`);
  }

  const fetchRef = useRef(null);

  // useEffect(() => {
  //   if (visible) {
  //     setSelectedUserForEdit(undefined);
  //   }
  // }, [selectedUserForEdit]);

  // useEffect(() => {
  //   setSelectedUserForEdit(undefined);
  // }, [visible]);

  const onClose = () => {
    // setSelectedUserForEdit(null);
    fetchUserDetails((route as any)?.id);
  };

  const user = singleUserInfo?.data;
  return (
    <React.Fragment>
      <CustomerLayout userId={(route as any)?.id as string}>
        <div className="bg-white">
          <CustomerHeader
            leftarea={"Customer Information"}
            rightarea={
              ""
              // <Button
              //   type="primary"
              //   // onClick={() =>
              //   //   setSelectedUserForEdit((route as any)?.userId as string)
              //   // }
              //   danger
              // >
              //   <EditOutlined /> Edit
              // </Button>
            }
          />
          <div className="details-area">
            <div className="pt-4">
              <div className="inner-body">
                <div className="single">
                  <span className="info-name">Customer Name</span>
                  <span className="info-desc">{user?.fullName}</span>
                </div>

                <div className="single">
                  <span className="info-name">Customer UserID</span>
                  <span className="info-desc">{user?.userId}</span>
                </div>

                <div className="single">
                  <span className="info-name">Customer ID</span>
                  <span className="info-desc">{user?.id}</span>
                </div>

                <div className="single">
                  <span className="info-name">Customer balance</span>
                  <span className="info-desc">&#2547;{user?.balance || 0}</span>
                </div>

                <div className="single">
                  <span className="info-name">Mobile Number</span>
                  <span className="info-desc">
                    {user?.mobileNumber.split("+88")}
                  </span>
                </div>

                {user?.email ? (
                  <div className="single">
                    <span className="info-name">Email Address</span>
                    <span className="info-desc">{user?.email}</span>
                  </div>
                ) : undefined}

                {/* <div className="single">
                  <span className="info-name">Owner Id</span>
                  <span className="info-desc">{user?.ownerId}</span>
                </div>

                <div className="single">
                  <span className="info-name">Address</span>
                  <span className="info-desc">{user?.address}</span>
                </div>

                <div className="single">
                  <span className="info-name">Area</span>
                  <span className="info-desc">{user?.area}</span>
                </div>

                <div className="single">
                  <span className="info-name">City</span>
                  <span className="info-desc">{user?.city}</span>
                </div>

                <div className="single">
                  <span className="info-name">Country</span>
                  <span className="info-desc">{user?.country}</span>
                </div> */}
                {user?.referralCode ? (
                  <div className="single">
                    <span className="info-name">Referral Code</span>
                    <span className="info-desc">
                      {user?.referralCode?.replace("_", " ")}
                    </span>
                  </div>
                ) : undefined}

                <div className="single">
                  <span className="info-name">Joining Date</span>
                  <span className="info-desc">
                    {moment(user?.createdAt).format("lll")}
                  </span>
                </div>

                <div className="single">
                  <span className="info-name">Status</span>
                  <div className="info-desc">
                    <span
                      className={`radius-btn ${user?.status?.toLowerCase()}-btn`}
                    >
                      {user?.status?.split("_").join(" ")}
                    </span>
                  </div>
                </div>

                <div className="single">
                  <span className="info-name">Rattings</span>
                  <span className="info-desc">
                    <Rate value={user?.rating || 0} disabled />
                    <small className="ml-1">({user?.numberOfRating})</small>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </CustomerLayout>
    </React.Fragment>
  );
};
UserDetails.propTypes = {
  match: PropTypes.object,
  params: PropTypes.object,
};
export default UserDetails;
